import { VirtualItem } from "@tanstack/react-virtual";
import { AnserJsonEntry } from "anser";
import { camelCase } from "lodash-es";
import cx from "classnames";

import ThemedLogsHighlightedText from "./HighlightedText";
import styles from "./styles.module.css";
import { getLogLineStyles } from "./utils";

type VirtualRowProps = {
  virtualRow: VirtualItem;
  lineEntries: AnserJsonEntry[];
  searchText: string;
  currentOccurrenceIndex: number | undefined;
  searchOccurrences: { lineIndex: number; occurrenceIndex: number }[];
  measureElement: (element: Element | null) => void;
};

const ThemedLogsVirtualRow = ({
  virtualRow,
  lineEntries,
  searchText,
  currentOccurrenceIndex,
  searchOccurrences,
  measureElement,
}: VirtualRowProps) => {
  return (
    <div key={virtualRow.key} data-index={virtualRow.index} ref={measureElement}>
      {lineEntries.map((entry, index) => (
        <span
          className={cx(styles[camelCase(entry.fg)])}
          style={getLogLineStyles(entry)}
          key={`entry-${index}`}
        >
          {entry.content.toLowerCase().includes(searchText.toLowerCase()) ? (
            <ThemedLogsHighlightedText
              text={entry.content}
              searchText={searchText}
              lineIndex={virtualRow.index}
              currentOccurrenceIndex={currentOccurrenceIndex}
              searchOccurrences={searchOccurrences}
            />
          ) : (
            entry.content
          )}
        </span>
      ))}
    </div>
  );
};

export default ThemedLogsVirtualRow;
